// Table elements
export const DATA_TABLE = "data-table";
export const DATA_TABLE_HEADER = "data-table-header";
export const DATA_TABLE_BODY = "data-table-body";
export const DATA_TABLE_ROW = "data-table-row";
export const DATA_TABLE_CELL = "data-table-cell";
export const DATA_TABLE_LOADING = "data-table-loading";
export const DATA_TABLE_NO_RESULTS = "data-table-no-results";

// Related Record Tabs
export const RELATED_RECORD_TABS_NO_RECORDS_MESSAGE = "no-records-message";
export const RELATED_RECORD_TABS_OVERLAY_SETTINGS_BUTTON =
	"related-record-tabs-overlay-settings-button";
export const RELATED_RECORD_TABS_EDIT_BUTTON =
	"related-record-tabs-edit-button";
export const RELATED_RECORD_TABS_DELETE_BUTTON =
	"related-record-tabs-delete-button";
export const RELATED_RECORD_TABS_DELETE_BUTTON_CONFIRMATION_MODAL =
	"delete-button-confirmation-modal";
export const RELATED_RECORD_TABS_DELETE_BUTTON_CANCEL_BUTTON =
	"related-record-tabs-delete-button-cancel-button";
export const RELATED_RECORD_TABS_DELETE_BUTTON_CONFIRM_BUTTON =
	"related-record-tabs-delete-button-confirm-button";

// Views menu
export const DATA_TABLE_VIEWS_MENU_BUTTON = "data-table-views-menu-button";
export const DATA_TABLE_VIEWS_MENU_CREATE_FORM =
	"data-table-views-menu-create-form";
export const DATA_TABLE_VIEWS_MENU_CREATE_BUTTON =
	"data-table-views-menu-create-button";

// global test-ids
export const DATE_PICKER_INPUT = "date-picker-input";

// Layout
export const MAIN_LAYOUT = "main-layout";
export const MAIN_NAV = "main-nav-sidebar";

// Actions
export const CREATE_SHIFT_BUTTON = "create-shift-button";
export const CREATE_SHIFT_DRAWER = "create-shift-drawer";
export const SHIFT_DETAIL_DRAWER = "shift-detail-drawer";
export const SHIFT_DESCRIPTION_FIELD = "shift-description-field";
export const SHIFT_UPDATE_BUTTON = "shift-update-button";
export const SHIFT_CANCEL_BUTTON = "shift-cancel-button";

// file exports
export const FILE_EXPORTS_TABLE = "file-exports-table";
export const FILE_EXPORTS_EXPORT_BUTTON = "file-exports-export-button";
export const FILE_EXPORTS_CREATE_MODAL = "file-exports-create-modal";
export const FILE_EXPORTS_DETAILS_MODAL = "file-exports-details-modal";
export const FILE_EXPORTS_DOWNLOAD_BUTTON = "file-exports-download-button";
export const FILE_EXPORTS_TYPE_SELECT = "file-exports-type-select";
export const FILE_EXPORTS_QUEUE_BUTTON = "file-exports-queue-button";
export const FILE_EXPORTS_BRANCH_SELECT = "file-exports-branch-select";
export const FILE_EXPORTS_DATE_RANGE_INPUT = "file-exports-date-range-input";

// Client Profile Page
export const CLIENT_PROFILE_GENERAL_SECTION = {
	NAME: "client-profile-general",
	EDIT_BUTTON: "client-profile-general-edit-button",
	MODAL: "client-profile-general-edit-modal",
	FIELDS: {
		STATUS: "client-profile-general-status",
		BRANCH: "client-profile-general-branch",
		FIRST_NAME: "client-profile-general-first-name",
		MIDDLE_NAME: "client-profile-general-middle-name",
		LAST_NAME: "client-profile-general-last-name",
		DATE_OF_BIRTH: "client-profile-general-date-of-birth",
		GENDER: "client-profile-general-gender",
		EMAIL_ADDRESS: "client-profile-general-email-address",
		PRIMARY_PHONE: "client-profile-general-primary-phone",
		SECONDARY_PHONE: "client-profile-general-secondary-phone",
		SSN: "client-profile-general-ssn",
		MEDICAID_ID: "client-profile-general-medicaid-id",
		ALTERNATE_MEDICAID_ID: "client-profile-general-alternate-medicaid-id",
	},
	INPUTS: {
		STATUS: "client-profile-general-status-input",
		BRANCH: "client-profile-general-branch-input",
		FIRST_NAME: "client-profile-general-first-name-input",
		MIDDLE_NAME: "client-profile-general-middle-name-input",
		LAST_NAME: "client-profile-general-last-name-input",
		DATE_OF_BIRTH: "client-profile-general-date-of-birth-input",
		GENDER: "client-profile-general-gender-input",
		EMAIL_ADDRESS: "client-profile-general-email-address-input",
		PRIMARY_PHONE: "client-profile-general-primary-phone-input",
		SECONDARY_PHONE: "client-profile-general-secondary-phone-input",
		SSN: "client-profile-general-ssn-input",
		MEDICAID_ID: "client-profile-general-medicaid-id-input",
		ALTERNATE_MEDICAID_ID: "client-profile-general-alternate-medicaid-id-input",
	},
};
export const CLIENT_PROFILE_BILLING_SECTION = {
	NAME: "client-profile-billing",
	EDIT_BUTTON: "client-profile-billing-edit-button",
	MODAL: "client-profile-billing-edit-modal",
	FIELDS: {
		PAYER_SOURCE: "client-profile-billing-payer-source",
		HHAX_ADMISSION_ID: "client-profile-billing-hhax-admission-id",
		THERAP_FORM_ID: "client-profile-billing-therap-form-id",
		HELPER_BEES_ID: "client-profile-billing-helper-bees-id",
	},
	INPUTS: {
		PAYER_SOURCE: "client-profile-billing-payer-source-input",
		HHAX_ADMISSION_ID: "client-profile-billing-hhax-admission-id-input",
		THERAP_FORM_ID: "client-profile-billing-therap-form-id-input",
		HELPER_BEES_ID: "client-profile-billing-helper-bees-id-input",
	},
};
export const CLIENT_PROFILE_MEDICAL_SECTION = {
	NAME: "client-profile-medical",
	EDIT_BUTTON: "client-profile-medical-edit-button",
	MODAL: "client-profile-medical-edit-modal",
	FIELDS: {
		PCP_PROVIDERS: "client-profile-medical-pcp-providers",
		SPECIALIST_PROVIDERS: "client-profile-medical-specialist-providers",
		SKILLED_CARE_PROVIDERS: "client-profile-medical-skilled-care-providers",
		ASSIGNED_RN: "client-profile-medical-assigned-rn",
		RN_ASSESSMENT_FREQUENCY: "client-profile-medical-rn-assessment-frequency",
		PROGRAM_HISTORY: "client-profile-medical-program-history",
		DIAGNOSIS_CODES: "client-profile-medical-diagnosis-codes",
	},
	INPUTS: {
		PCP_PROVIDERS: "client-profile-medical-pcp-providers-input",
		SPECIALIST_PROVIDERS: "client-profile-medical-specialist-providers-input",
		SKILLED_CARE_PROVIDERS:
			"client-profile-medical-skilled-care-providers-input",
		ASSIGNED_RN: "client-profile-medical-assigned-rn-input",
		RN_ASSESSMENT_FREQUENCY:
			"client-profile-medical-rn-assessment-frequency-input",
		PROGRAM_HISTORY: "client-profile-medical-program-history-input",
		DIAGNOSIS_CODES: "client-profile-medical-diagnosis-codes-input",
	},
};
export const CLIENT_PROFILE_ATTRIBUTES_SECTION = {
	NAME: "client-profile-attributes",
	EDIT_BUTTON: "client-profile-attributes-edit-button",
	MODAL: "client-profile-attributes-edit-modal",
	FIELDS: {
		NEEDS: "client-profile-attributes-needs",
		REQUIRES_CERTIFIED: "client-profile-attributes-requires-certified",
		REQUIRES_TRAINING_ON: "client-profile-attributes-requires-training-on",
		DME: "client-profile-attributes-dme",
		DO_NOT_RESUSCITATE: "client-profile-attributes-do-not-resuscitate",
		HOSPICE: "client-profile-attributes-hospice",
		SMOKER: "client-profile-attributes-smoker",
		VACCINATED: "client-profile-attributes-vaccinated",
		NEWBORN: "client-profile-attributes-newborn",
		EVV_CONSENT_GRANTED: "client-profile-attributes-evv-consent-granted",
	},
	INPUTS: {
		NEEDS: "client-profile-attributes-needs-input",
		REQUIRES_CERTIFIED: "client-profile-attributes-requires-certified-input",
		REQUIRES_TRAINING_ON:
			"client-profile-attributes-requires-training-on-input",
		DME: "client-profile-attributes-dme-input",
		DO_NOT_RESUSCITATE: "client-profile-attributes-do-not-resuscitate-input",
		HOSPICE: "client-profile-attributes-hospice-input",
		SMOKER: "client-profile-attributes-smoker-input",
		VACCINATED: "client-profile-attributes-vaccinated-input",
		NEWBORN: "client-profile-attributes-newborn-input",
		EVV_CONSENT_GRANTED: "client-profile-attributes-evv-consent-granted-input",
	},
};

export const CLIENT_PROFILE_EDIT_BUTTON_TEMPLATE =
	"client-profile-${section}-edit-button";
export const CLIENT_PROFILE_EDIT_MODAL_TEMPLATE =
	"client-profile-${section}-edit-modal";

export const CLIENT_PROFILE_FIRST_TAB_GROUP_ADD_BUTTON =
	"add-button-first-tab-group";
export const CLIENT_PROFILE_SECOND_TAB_GROUP_ADD_BUTTON =
	"add-button-second-tab-group";

// Client Profile Tabs
export const CLIENT_PROFILE_FILES = {
	TAB: "client-profile-files",
	TAB_PANEL: "client-profile-files-tab-panel",
	CREATE_MODAL: "client-profile-files-create-modal",
	UPDATE_MODAL: "client-profile-files-update-modal",
	SAVE_BUTTON: "client-profile-files-create-modal-save-button",
	CANCEL_BUTTON: "client-profile-files-create-modal-cancel-button",
	FIELDS: {
		TYPE: "client-profile-files-type",
		FILE: "client-profile-files-file",
		CAREGIVER: "client-profile-files-caregiver",
		COMPLETED_BY: "client-profile-files-completed-by",
		EXPIRATION_DATE: "client-profile-files-expiration-date",
		PAY_PERIOD_START: "client-profile-files-pay-period-start",
		PAY_PERIOD_END: "client-profile-files-pay-period-end",
		UPLOADED_BY: "client-profile-files-uploaded-by",
		UPLOAD_DATE: "client-profile-files-upload-date",
	},
	INPUTS: {
		TYPE: "client-profile-files-type-input",
		FILE: "client-profile-files-file-input",
		CAREGIVER: "client-profile-files-caregiver-input",
		COMPLETED_DATE: "client-profile-files-completed-date-input",
		EXPIRATION_DATE: "client-profile-files-expiration-date-input",
		PAY_PERIOD: "client-profile-files-pay-period-input",
	},
};

export const CLIENT_PROFILE_JOURNAL_ENTRIES = {
	TAB: "client-profile-journal-entries",
	TAB_PANEL: "client-profile-journal-entries-tab-panel",
	CREATE_MODAL: "client-profile-journal-entries-create-modal",
	UPDATE_MODAL: "client-profile-journal-entries-update-modal",
	SAVE_BUTTON: "client-profile-journal-entries-create-modal-save-button",
	CANCEL_BUTTON: "client-profile-journal-entries-create-modal-cancel-button",
	UPDATE_BUTTON: "client-profile-journal-entries-update-modal-save-button",
	CANCEL_UPDATE_BUTTON:
		"client-profile-journal-entries-update-modal-cancel-button",
	FIELDS: {
		TAG: "client-profile-journal-entries-tag",
		NOTE: "client-profile-journal-entries-note",
		AUTHOR: "client-profile-journal-entries-author",
		DATE: "client-profile-journal-entries-date",
	},
	INPUTS: {
		TAG: "client-profile-journal-entries-tag-input",
		NOTE: "client-profile-journal-entries-note-input",
	},
};
export const CLIENT_PROFILE_CARE_SHEETS = {
	TAB: "client-profile-care-sheets",
	LIST: "client-profile-care-sheets-list",
	DETAILS: "client-profile-care-sheets-details",
	UPLOAD: "client-profile-care-sheets-upload",
	DOWNLOAD: "client-profile-care-sheets-download",
	DELETE: "client-profile-care-sheets-delete",
};
export const CLIENT_PROFILE_NURSE_ASSESSMENTS = {
	TAB: "client-profile-nurse-assessments",
	CREATE_MODAL: "client-profile-nurse-assessments-create-modal",
	UPDATE_MODAL: "client-profile-nurse-assessments-update-modal",
};
export const CLIENT_PROFILE_ADDRESSES = {
	TAB: "client-profile-addresses",
	CREATE_MODAL: "client-profile-addresses-create-modal",
	UPDATE_MODAL: "client-profile-addresses-update-modal",
};
export const CLIENT_PROFILE_AUTHORIZATIONS = {
	TAB: "client-profile-authorizations",
	TAB_PANEL: "client-profile-authorizations-tab-panel",
	CREATE_MODAL: "client-profile-authorizations-create-modal",
	UPDATE_MODAL: "client-profile-authorizations-update-modal",
	SAVE_BUTTON: "client-profile-authorizations-create-modal-save-button",
	CANCEL_BUTTON: "client-profile-authorizations-create-modal-cancel-button",
	UPDATE_BUTTON: "client-profile-authorizations-update-modal-save-button",
	CANCEL_UPDATE_BUTTON:
		"client-profile-authorizations-update-modal-cancel-button",
	FIELDS: {
		TYPE: "client-profile-authorizations-type",
		PAYER_SOURCE: "client-profile-authorizations-payer-source",
		NUMBER: "client-profile-authorizations-number",
		RECEIVED_DATE: "client-profile-authorizations-received-date",
		START_DATE: "client-profile-authorizations-start-date",
		END_DATE: "client-profile-authorizations-end-date",
		UNITS: "client-profile-authorizations-units",
		WEEKLY_HOURS: "client-profile-authorizations-weekly-hours",
		MONTHLY_HOURS: "client-profile-authorizations-monthly-hours",
		RESPITE_HOURS: "client-profile-authorizations-respite-hours",
		RESPITE_FREQUENCY: "client-profile-authorizations-respite-frequency",
		PAYER_CODE: "client-profile-authorizations-payer-code",
		PROGRAM_CODE: "client-profile-authorizations-program-code",
		SERVICE_CODE: "client-profile-authorizations-service-code",
		CLIENT_PAYER_ID: "client-profile-authorizations-client-payer-id",
	},
	INPUTS: {
		TYPE: "client-profile-authorizations-type-input",
		PAYER_SOURCE: "client-profile-authorizations-payer-source-input",
		NUMBER: "client-profile-authorizations-number-input",
		RECEIVED_DATE: "client-profile-authorizations-received-date-input",
		START_DATE: "client-profile-authorizations-start-date-input",
		END_DATE: "client-profile-authorizations-end-date-input",
		UNITS: "client-profile-authorizations-units-input",
		WEEKLY_HOURS: "client-profile-authorizations-weekly-hours-input",
		MONTHLY_HOURS: "client-profile-authorizations-monthly-hours-input",
		RESPITE_HOURS: "client-profile-authorizations-respite-hours-input",
		RESPITE_FREQUENCY: "client-profile-authorizations-respite-frequency-input",
		PAYER_CODE: "client-profile-authorizations-payer-code-input",
		PROGRAM_CODE: "client-profile-authorizations-program-code-input",
		SERVICE_CODE: "client-profile-authorizations-service-code-input",
		CLIENT_PAYER_ID: "client-profile-authorizations-client-payer-id-input",
	},
};
export const CLIENT_PROFILE_CONTACTS = {
	TAB: "client-profile-contacts",
	TAB_PANEL: "client-profile-contacts-tab-panel",
	CREATE_MODAL: "client-profile-contacts-create-modal",
	UPDATE_MODAL: "client-profile-contacts-update-modal",
	SAVE_BUTTON: "client-profile-contacts-create-modal-save-button",
	CANCEL_BUTTON: "client-profile-contacts-create-modal-cancel-button",
	UPDATE_BUTTON: "client-profile-contacts-update-modal-save-button",
	CANCEL_UPDATE_BUTTON: "client-profile-contacts-update-modal-cancel-button",
	FIELDS: {
		NAME: "client-profile-contacts-name",
		ROLE: "client-profile-contacts-role",
		RELATIONSHIP: "client-profile-contacts-relationship",
		EMAIL: "client-profile-contacts-email",
		HOME_PHONE: "client-profile-contacts-home-phone",
		MOBILE_PHONE: "client-profile-contacts-mobile-phone",
		WORK_PHONE: "client-profile-contacts-work-phone",
		STREET_ADDRESS: "client-profile-contacts-street-address",
		CITY_STATE_ZIP: "client-profile-contacts-city-state-zip",
	},
	INPUTS: {
		NAME: "client-profile-contacts-name-input",
		ROLE: "client-profile-contacts-role-input",
		RELATIONSHIP: "client-profile-contacts-relationship-input",
		HOME_PHONE: "client-profile-contacts-home-phone-input",
		MOBILE_PHONE: "client-profile-contacts-mobile-phone-input",
		WORK_PHONE: "client-profile-contacts-work-phone-input",
		EMAIL: "client-profile-contacts-email-input",
		STREET_1: "client-profile-contacts-street-1-input",
		STREET_2: "client-profile-contacts-street-2-input",
		CITY: "client-profile-contacts-city-input",
		STATE: "client-profile-contacts-state-input",
		ZIP: "client-profile-contacts-zip-input",
	},
};

export const CAREGIVER_PROFILE_GENERAL_SECTION = {
	NAME: "caregiver-profile-general",
	EDIT_BUTTON: "caregiver-profile-general-edit-button",
	MODAL: "caregiver-profile-general-edit-modal",
	FIELDS: {
		STATUS: "caregiver-profile-general-status",
		BRANCH: "caregiver-profile-general-branch",
		SECOND_BRANCH: "caregiver-profile-general-second-branch",
		USERNAME: "caregiver-profile-general-username",
		FIRST_NAME: "caregiver-profile-general-first-name",
		MIDDLE_NAME: "caregiver-profile-general-middle-name",
		LAST_NAME: "caregiver-profile-general-last-name",
		DATE_OF_BIRTH: "caregiver-profile-general-date-of-birth",
		GENDER: "caregiver-profile-general-gender",
		EMAIL_ADDRESS: "caregiver-profile-general-email-address",
		PRIMARY_PHONE: "caregiver-profile-general-primary-phone",
		SECONDARY_PHONE: "caregiver-profile-general-secondary-phone",
		SSN: "caregiver-profile-general-ssn",
		ADP_FILE_NUMBER: "caregiver-profile-general-adp-file-number",
		NPI: "caregiver-profile-general-npi",
		PAY_RATE: "caregiver-profile-general-pay-rate",
		THERAP_FORM_ID: "caregiver-profile-general-therap-form-id",
		V2_ENABLED: "caregiver-profile-general-v2-enabled",
		CARE_SHEETS_ENABLED: "caregiver-profile-general-care-sheets-enabled",
		CARE_SHEETS_ENABLED_START_AT:
			"caregiver-profile-general-care-sheets-enabled-start-at",
	},
	INPUTS: {
		STATUS: "caregiver-profile-general-status-input",
		BRANCH: "caregiver-profile-general-branch-input",
		SECOND_BRANCH: "caregiver-profile-general-second-branch-input",
		FIRST_NAME: "caregiver-profile-general-first-name-input",
		MIDDLE_NAME: "caregiver-profile-general-middle-name-input",
		LAST_NAME: "caregiver-profile-general-last-name-input",
		DATE_OF_BIRTH: "caregiver-profile-general-date-of-birth-input",
		GENDER: "caregiver-profile-general-gender-input",
		EMAIL_ADDRESS: "caregiver-profile-general-email-address-input",
		PRIMARY_PHONE: "caregiver-profile-general-primary-phone-input",
		SECONDARY_PHONE: "caregiver-profile-general-secondary-phone-input",
		SSN: "caregiver-profile-general-ssn-input",
		ADP_FILE_NUMBER: "caregiver-profile-general-adp-file-number-input",
		NPI: "caregiver-profile-general-npi-input",
		PAY_RATE: "caregiver-profile-general-pay-rate-input",
		THERAP_FORM_ID: "caregiver-profile-general-therap-form-id-input",
		V2_ENABLED: "caregiver-profile-general-v2-enabled-input",
		CARE_SHEETS_ENABLED: "caregiver-profile-general-care-sheets-enabled-input",
		CARE_SHEETS_ENABLED_START_AT:
			"caregiver-profile-general-care-sheets-enabled-start-at-input",
	},
};

export const CAREGIVER_PROFILE_PREFERENCES_SECTION = {
	NAME: "caregiver-profile-preferences",
	EDIT_BUTTON: "caregiver-profile-preferences-edit-button",
	MODAL: "caregiver-profile-preferences-edit-modal",
	FIELDS: {
		PREFERRED_SERVICE_RADIUS:
			"caregiver-profile-preferences-preferred-service-radius",
		PREFERRED_WEEKLY_WORKING_HOURS:
			"caregiver-profile-preferences-preferred-weekly-working-hours",
		WILLINGNESS_TO_COVER_SHIFTS:
			"caregiver-profile-preferences-willingness-to-cover-shifts",
		PREFERRED_SHIFT_TYPE: "caregiver-profile-preferences-preferred-shift-type",
		PREFERRED_HOURS_PER_WEEK:
			"caregiver-profile-preferences-preferred-hours-per-week",
		PREFERRED_DISTANCE: "caregiver-profile-preferences-preferred-distance",
		FIFTEEN_MINUTE_REMINDER:
			"caregiver-profile-preferences-fifteen-minute-reminder",
		END_OF_DAY_REMINDER: "caregiver-profile-preferences-end-of-day-reminder",
		END_OF_WEEK_REMINDER: "caregiver-profile-preferences-end-of-week-reminder",
	},
	INPUTS: {
		PREFERRED_SERVICE_RADIUS:
			"caregiver-profile-preferences-preferred-service-radius-input",
		PREFERRED_WEEKLY_WORKING_HOURS:
			"caregiver-profile-preferences-preferred-weekly-working-hours-input",
		WILLINGNESS_TO_COVER_SHIFTS:
			"caregiver-profile-preferences-willingness-to-cover-shifts-input",
		FIFTEEN_MINUTE_REMINDER:
			"caregiver-profile-preferences-fifteen-minute-reminder-input",
		END_OF_DAY_REMINDER:
			"caregiver-profile-preferences-end-of-day-reminder-input",
		END_OF_WEEK_REMINDER:
			"caregiver-profile-preferences-end-of-week-reminder-input",
	},
};

export const CAREGIVER_PROFILE_ATTRIBUTES_SECTION = {
	NAME: "caregiver-profile-attributes",
	EDIT_BUTTON: "caregiver-profile-attributes-edit-button",
	MODAL: "caregiver-profile-attributes-edit-modal",
	FIELDS_BASE: "caregiver-profile-attributes",
	FIELDS: {
		// Provided Services
		CAN_PROVIDE_PERSONAL_CARE:
			"caregiver-profile-attributes-can-provide-personal-care",
		CAN_PROVIDE_COMPANION_CARE:
			"caregiver-profile-attributes-can-provide-companion-care",
		CAN_PROVIDE_RESPITE_CARE:
			"caregiver-profile-attributes-can-provide-respite-care",
		CAN_PROVIDE_SKILLED_CARE:
			"caregiver-profile-attributes-can-provide-skilled-care",
		// Certifications
		CERTIFIED_CNA: "caregiver-profile-attributes-certified-cna",
		CERTIFIED_HHA: "caregiver-profile-attributes-certified-hha",
		CERTIFIED_LPN: "caregiver-profile-attributes-certified-lpn",
		CERTIFIED_RN: "caregiver-profile-attributes-certified-rn",
		// Training
		HAS_TRAINING_ON_DEMENTIA:
			"caregiver-profile-attributes-has-training-on-dementia",
		HAS_TRAINING_ON_ALZHEIMERS:
			"caregiver-profile-attributes-has-training-on-alzheimers",
		HAS_TRAINING_ON_DIABETES:
			"caregiver-profile-attributes-has-training-on-diabetes",
		// Other
		IS_SMOKER: "caregiver-profile-attributes-is-smoker",
		IS_VACCINATED: "caregiver-profile-attributes-is-vaccinated",
		HAS_PET_ALLERGIES: "caregiver-profile-attributes-has-pet-allergies",
		WOTC: "caregiver-profile-attributes-wotc",
	},
	INPUTS_BASE: "caregiver-profile-attributes-inputs",
	INPUTS: {
		// Provided Services
		CAN_PROVIDE_PERSONAL_CARE:
			"caregiver-profile-attributes-can-provide-personal-care-input",
		CAN_PROVIDE_COMPANION_CARE:
			"caregiver-profile-attributes-can-provide-companion-care-input",
		CAN_PROVIDE_RESPITE_CARE:
			"caregiver-profile-attributes-can-provide-respite-care-input",
		CAN_PROVIDE_SKILLED_CARE:
			"caregiver-profile-attributes-can-provide-skilled-care-input",
		// Certifications
		CERTIFIED_CNA: "caregiver-profile-attributes-certified-cna-input",
		CERTIFIED_HHA: "caregiver-profile-attributes-certified-hha-input",
		CERTIFIED_LPN: "caregiver-profile-attributes-certified-lpn-input",
		CERTIFIED_RN: "caregiver-profile-attributes-certified-rn-input",
		// Training
		HAS_TRAINING_ON_DEMENTIA:
			"caregiver-profile-attributes-has-training-on-dementia-input",
		HAS_TRAINING_ON_ALZHEIMERS:
			"caregiver-profile-attributes-has-training-on-alzheimers-input",
		HAS_TRAINING_ON_DIABETES:
			"caregiver-profile-attributes-has-training-on-diabetes-input",
		// Other
		IS_SMOKER: "caregiver-profile-attributes-is-smoker-input",
		IS_VACCINATED: "caregiver-profile-attributes-is-vaccinated-input",
		HAS_PET_ALLERGIES: "caregiver-profile-attributes-has-pet-allergies-input",
		WOTC: "caregiver-profile-attributes-wotc-input",
	},
};

export const CAREGIVER_PROFILE_EDIT_BUTTON_TEMPLATE =
	"caregiver-profile-${section}-edit-button";
export const CAREGIVER_PROFILE_EDIT_MODAL_TEMPLATE =
	"caregiver-profile-${section}-edit-modal";

export const CAREGIVER_PROFILE_JOURNAL_ENTRIES = {
	TAB: "caregiver-profile-journal-entries",
	PANEL: "caregiver-profile-journal-entries-panel",
	CREATE_MODAL: "caregiver-profile-journal-entries-create-modal",
	UPDATE_MODAL: "caregiver-profile-journal-entries-update-modal",
	FIELDS: {
		TAG: "caregiver-profile-journal-entries-tag",
		NOTE: "caregiver-profile-journal-entries-note",
		AUTHOR: "caregiver-profile-journal-entries-author",
		DATE: "caregiver-profile-journal-entries-date",
	},
	INPUTS: {
		TAG: "caregiver-profile-journal-entries-tag-input",
		NOTE: "caregiver-profile-journal-entries-note-input",
	},
	ACTIONS: {
		EDIT: "caregiver-profile-journal-entries-edit-button",
		DELETE: "caregiver-profile-journal-entries-delete-button",
	},
};

export const CAREGIVER_PROFILE_FILES = {
	TAB: "caregiver-profile-files",
	PANEL: "caregiver-profile-files-panel",
	CREATE_MODAL: "caregiver-profile-files-create-modal",
	UPDATE_MODAL: "caregiver-profile-files-update-modal",
	FIELDS: {
		TYPE: "caregiver-profile-files-type",
		FILE: "caregiver-profile-files-file",
		COMPLETED_DATE: "caregiver-profile-files-completed-date",
		UPLOAD_DATE: "caregiver-profile-files-upload-date",
		EXPIRATION_DATE: "caregiver-profile-files-expiration-date",
		PAY_PERIOD_START: "caregiver-profile-files-pay-period-start",
		PAY_PERIOD_END: "caregiver-profile-files-pay-period-end",
		UPLOADED_BY: "caregiver-profile-files-uploaded-by",
	},
	INPUTS: {
		TYPE: "caregiver-profile-files-type-input",
		FILE: "caregiver-profile-files-file-input",
		COMPLETED_DATE: "caregiver-profile-files-completed-date-input",
		EXPIRATION_DATE: "caregiver-profile-files-expiration-date-input",
		PAY_PERIOD: "caregiver-profile-files-pay-period-input",
	},
	ACTIONS: {
		EDIT: "caregiver-profile-files-edit-button",
		DELETE: "caregiver-profile-files-delete-button",
	},
};

// Mantine Demo Page
export const MANTINE_DEMO = {
	// Page elements
	PAGE: "mantine-demo-page",
	TITLE: "mantine-demo-title",
	DESCRIPTION: "mantine-demo-description",
	TABS: "mantine-demo-tabs",

	// Tab elements
	TAB_ELEMENTS: {
		DATE_TAB: "mantine-demo-date-tab",
		SELECT_TAB: "mantine-demo-select-tab",
		FILE_TAB: "mantine-demo-file-tab",
		MODAL_TAB: "mantine-demo-modal-tab",
	},

	// Section titles
	SECTION_TITLES: {
		DATE: "mantine-demo-date-section-title",
		SELECT: "mantine-demo-select-section-title",
		FILE: "mantine-demo-file-section-title",
		MODAL_DRAWER: "mantine-demo-modal-drawer-section-title",
	},

	// Date components
	DATE_COMPONENTS: {
		SECTION: "mantine-demo-date-components",
		DATE_PICKER: "mantine-demo-date-picker",
		DATE_RANGE_PICKER: "mantine-demo-date-range-picker",
		DATE_TIME_PICKER: "mantine-demo-date-time-picker",

		// Containers and labels
		DATE_PICKER_CONTAINER: "mantine-demo-date-picker-container",
		DATE_PICKER_LABEL: "mantine-demo-date-picker-label",
		DATE_RANGE_PICKER_CONTAINER: "mantine-demo-date-range-picker-container",
		DATE_RANGE_PICKER_LABEL: "mantine-demo-date-range-picker-label",
		DATE_TIME_PICKER_CONTAINER: "mantine-demo-date-time-picker-container",
		DATE_TIME_PICKER_LABEL: "mantine-demo-date-time-picker-label",
	},

	// Select components
	SELECT_COMPONENTS: {
		SECTION: "mantine-demo-select-components",
		SELECT: "mantine-demo-select",
		MULTI_SELECT: "mantine-demo-multi-select",
		TAGS_INPUT: "mantine-demo-tags-input",
		SLIDER: "mantine-demo-slider",

		// Containers and labels
		SELECT_CONTAINER: "mantine-demo-select-container",
		SELECT_LABEL: "mantine-demo-select-label",
		MULTI_SELECT_CONTAINER: "mantine-demo-multi-select-container",
		MULTI_SELECT_LABEL: "mantine-demo-multi-select-label",
		TAGS_INPUT_CONTAINER: "mantine-demo-tags-input-container",
		TAGS_INPUT_LABEL: "mantine-demo-tags-input-label",
		SLIDER_CONTAINER: "mantine-demo-slider-container",
		SLIDER_LABEL: "mantine-demo-slider-label",
	},

	// File components
	FILE_COMPONENTS: {
		SECTION: "mantine-demo-file-components",
		FILE_INPUT: "mantine-demo-file-input",
		FILE_INPUT_MULTIPLE: "mantine-demo-file-input-multiple",
		FILE_BUTTON: "mantine-demo-file-button",
		FILE_RESET_BUTTON: "mantine-demo-file-reset-button",
		FILE_DROP_ZONE: "mantine-demo-file-drop-zone",

		// Containers and labels
		FILE_INPUT_CONTAINER: "mantine-demo-file-input-container",
		FILE_INPUT_MULTIPLE_CONTAINER: "mantine-demo-file-input-multiple-container",
		FILE_INPUT_LABEL: "mantine-demo-file-input-label",
		FILE_INPUT_MULTIPLE_LABEL: "mantine-demo-file-input-multiple-label",
		FILE_INPUT_INFO: "mantine-demo-file-input-info",
		FILE_INPUT_MULTIPLE_INFO: "mantine-demo-file-input-multiple-info",
		FILE_BUTTON_CONTAINER: "mantine-demo-file-button-container",
		FILE_BUTTON_LABEL: "mantine-demo-file-button-label",
		FILE_BUTTON_INFO: "mantine-demo-file-button-info",
		FILE_DROP_ZONE_CONTAINER: "mantine-demo-file-drop-zone-container",
		FILE_DROP_ZONE_LABEL: "mantine-demo-file-drop-zone-label",
		FILE_DROP_ZONE_TEXT: "mantine-demo-file-drop-zone-text",
		FILE_DROP_ZONE_SUBTEXT: "mantine-demo-file-drop-zone-subtext",
	},

	// Modal & Drawer components
	MODAL_DRAWER_COMPONENTS: {
		SECTION: "mantine-demo-modal-drawer-components",
		OPEN_MODAL_BUTTON: "mantine-demo-open-modal-button",
		OPEN_DRAWER_BUTTON: "mantine-demo-open-drawer-button",
		MODAL: "mantine-demo-modal",
		MODAL_CONTENT: "mantine-demo-modal-content",
		MODAL_CONFIRM_BUTTON: "mantine-demo-modal-confirm-button",
		MODAL_CANCEL_BUTTON: "mantine-demo-modal-cancel-button",
		DRAWER: "mantine-demo-drawer",
		DRAWER_CONTENT_1: "mantine-demo-drawer-content-1",
		DRAWER_CONTENT_2: "mantine-demo-drawer-content-2",
		DRAWER_CLOSE_BUTTON: "mantine-demo-drawer-close-button",
	},
};

// Chat Components

// Main chat components
export const CHAT_CONTAINER = "chat-container";
export const CHAT_SIDEBAR = "chat-sidebar";
export const CHAT_DESKTOP_LAYOUT = "chat-desktop-layout";
export const CHAT_MOBILE_LAYOUT = "chat-mobile-layout";
export const CHAT_MAIN_CONTENT = "chat-main-content";
export const CHAT_BRANCH_MODE_SWITCH = "chat-branch-mode-switch";
export const CHAT_DISABLED_MESSAGE = "chat-disabled-message";

// Sidebar components
export const CHAT_SIDEBAR_HEADER = "chat-sidebar-header";
export const CHAT_TABS_LIST = "chat-tabs-list";
export const CHAT_MESSAGES_TAB = "chat-messages-tab";
export const CHAT_BROADCASTS_TAB = "chat-broadcasts-tab";
export const CHAT_CONVERSATION_SEARCH = "chat-conversation-search";
export const CHAT_NEW_CONVERSATION_BUTTON = "chat-new-conversation-button";
export const CHAT_CONVERSATION_LIST = "chat-conversation-list";
export const CHAT_CONVERSATION_ITEM = "chat-conversation-item";

// New conversation dialog
export const CHAT_NEW_CONVERSATION_DIALOG = "chat-new-conversation-dialog";
export const CHAT_NEW_CONVERSATION_SEARCH = "chat-new-conversation-search";
export const CHAT_NEW_CONVERSATION_USER_LIST =
	"chat-new-conversation-user-list";
export const CHAT_NEW_CONVERSATION_USER_ITEM =
	"chat-new-conversation-user-item";

// Chat area components
export const CHAT_AREA = "chat-area";
export const CHAT_HEADER = "chat-header";
export const CHAT_MESSAGES_CONTAINER = "chat-messages-container";
export const CHAT_MESSAGE = "chat-message";
export const CHAT_MESSAGE_SENT_STATUS = "chat-message-sent-status";

// Message input area
export const CHAT_INPUT_TEXTAREA = "chat-input-textarea";
export const CHAT_SEND_BUTTON = "chat-send-button";

// Care Forms
export const CARE_FORMS_LAYOUT = "care-forms-layout";
export const CARE_FORMS_TABLE = "care-forms-table";
export const CARE_FORMS_TABLE_ROW = "care-forms-table-row";
export const CARE_FORMS_CREATE_BUTTON = "care-forms-create-button";
export const CARE_FORMS_CREATE_MODAL = "care-forms-create-modal";
export const CARE_FORMS_CREATE_FORM = "care-forms-create-form";
export const CARE_FORMS_CREATE_FORM_SUBMIT_BUTTON =
	"care-forms-create-form-submit-button";
export const CARE_FORMS_CREATE_PAYER_SOURCE_SELECT =
	"care-forms-create-payer-source-select";
export const CARE_FORMS_CREATE_CARE_FORM_TYPE_SELECT =
	"care-forms-create-care-form-type-select";
export const CARE_FORMS_CREATE_CLIENT_SELECT =
	"care-forms-create-client-select";
export const CARE_FORMS_CREATE_ASSESSMENT_DATE_INPUT =
	"care-forms-create-assessment-date-input";

export const CARE_FORM_DETAIL_PAGE = "care-form-detail-page";
export const CARE_FORM_BACK_BUTTON = "care-form-back-button";
export const CARE_FORM_STATUS_BADGE = "care-form-status-badge";
export const CARE_FORM_ONLINE_ICON = "care-form-online-icon";
export const CARE_FORM_OFFLINE_ICON = "care-form-offline-icon";
export const CARE_FORM_SAVED_OFFLINE_TEXT = "care-form-saved-offline-text";
export const CARE_FORM_COMPLETE_FORM_BUTTON = "care-form-complete-form-button";
export const CARE_FORM_SAVE_FORM_BUTTON = "care-form-save-form-button";
export const CARE_FORM_ENABLE_OFFLINE_BACKUP_BUTTON =
	"care-form-enable-offline-backup-button";
export const CARE_FORM_PASSWORD_MODAL = "care-form-password-modal";
export const CARE_FORM_PASSWORD_MODAL_PASSWORD_INPUT =
	"care-form-password-modal-password-input";
export const CARE_FORM_PASSWORD_MODAL_CONFIRM_PASSWORD_INPUT =
	"care-form-password-modal-confirm-password-input";
export const CARE_FORM_PASSWORD_MODAL_CONFIRM_PASSWORD_BUTTON =
	"care-form-password-modal-confirm-password-button";
export const CARE_FORM_OFFLINE_RESTORE_DIALOG =
	"care-form-offline-restore-dialog";
export const CARE_FORM_OFFLINE_DELETE_BACKUP_BUTTON =
	"care-form-offline-delete-backup-button";
export const CARE_FORM_OFFLINE_RESTORE_BACKUP_BUTTON =
	"care-form-offline-restore-backup-button";

export const CARE_FORM_DIALOG = "care-form-dialog";
export const CARE_FORM_DIALOG_SIGNATURE_CLEAR_BUTTON =
	"care-form-dialog-signature-clear-button";

export const CASES_CONTAINER = "cases-container";
export const CASES_DATA_TABLE = "cases-data-table";

export const CASES_CREATE_BUTTON = "cases-create-button";
export const CASES_CREATE_MODAL = "cases-create-modal";
export const CASES_CREATE_FORM_TYPE_SELECT = "cases-create-form-type-select";

export const CASES_CREATE_FORM = "cases-create-form";
export const CASES_CREATE_FORM_SUBMIT_BUTTON =
	"cases-create-form-submit-button";
export const CASES_CREATE_FORM_BRANCH_SELECT =
	"cases-create-form-branch-select";

export const CASES_CREATE_OTHER_DESCRIPTION_INPUT =
	"cases-create-other-description-input";

export const CASES_CREATE_ALLEGED_EMPLOYEE_DATE_INPUT =
	"cases-create-alleged-employee-date-input";
export const CASES_CREATE_ALLEGED_EMPLOYEE_CAREGIVER_SELECT =
	"cases-create-alleged-employee-caregiver-select";
export const CASES_CREATE_ALLEGED_EMPLOYEE_CLIENT_SELECT =
	"cases-create-alleged-employee-client-select";
export const CASES_CREATE_ALLEGED_EMPLOYEE_ADDRESS_SELECT =
	"cases-create-alleged-employee-address-select";
export const CASES_CREATE_ALLEGED_EMPLOYEE_POLICE_SELECT =
	"cases-create-alleged-employee-police-select";
export const CASES_CREATE_ALLEGED_EMPLOYEE_DESCRIPTION_INPUT =
	"cases-create-alleged-employee-description-input";

export const CASES_CREATE_HARASSMENT_ABUSE_DATE_OF_INCIDENT_INPUT =
	"cases-create-harassment-abuse-date-of-incident-input";
export const CASES_CREATE_HARASSMENT_ABUSE_DATE_NOTIFIED_INPUT =
	"cases-create-harassment-abuse-date-notified-input";
export const CASES_CREATE_HARASSMENT_ABUSE_TIME_OF_INCIDENT_INPUT =
	"cases-create-harassment-abuse-time-of-incident-input";
export const CASES_CREATE_HARASSMENT_ABUSE_CLIENT_SELECT =
	"cases-create-harassment-abuse-client-select";
export const CASES_CREATE_HARASSMENT_ABUSE_CAREGIVER_SELECT =
	"cases-create-harassment-abuse-caregiver-select";
export const CASES_CREATE_HARASSMENT_ABUSE_ADDRESS_SELECT =
	"cases-create-harassment-abuse-address-select";
export const CASES_CREATE_HARASSMENT_ABUSE_PAYER_SOURCE_SELECT =
	"cases-create-harassment-abuse-payer-source-select";
export const CASES_CREATE_HARASSMENT_ABUSE_DESCRIPTION_INPUT =
	"cases-create-harassment-abuse-description-input";
export const CASES_CREATE_HARASSMENT_ABUSE_CONTACT_NAME_INPUT =
	"cases-create-harassment-abuse-contact-name-input";
export const CASES_CREATE_HARASSMENT_ABUSE_CONTACT_PHONE_INPUT =
	"cases-create-harassment-abuse-contact-phone-input";
export const CASES_CREATE_HARASSMENT_ABUSE_ADDITIONAL_INFORMATION_INPUT =
	"cases-create-harassment-abuse-additional-information-input";

// v3 common components
export const V3_COMMON_COMBOBOX_ITEM = "v3-common-combobox-item";
export const V3_COMMON_COMMAND_ITEM = "v3-common-command-item";
export const V3_COMMON_COMMAND_EMPTY = "v3-common-command-empty";
// caregiver app
export const CAREGIVER_APP_LAYOUT = "caregiver-app-layout";
export const CAREGIVER_APP_NAV_SHIFTS = "caregiver-app-nav-shifts";
export const CAREGIVER_APP_NAV_PICKUP = "caregiver-app-nav-pickup";
export const CAREGIVER_APP_NAV_CARE_SHEETS = "caregiver-app-nav-care-sheets";
